@switch (viewState()) {
  @case (RegistrationFinishViewState.Loading) {
    <div class="tw-flex tw-items-center tw-justify-center">
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin bwi-3x"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    </div>
  }
  @case (RegistrationFinishViewState.Error) {
    <p data-testid="registration-finish-error-message">
      {{ errorMessageI18nKey() | i18n }}
    </p>
    @if (errorButton(); as button) {
      <button
        bitButton
        type="button"
        buttonType="primary"
        block
        (click)="onErrorButtonClick()"
        data-testid="registration-finish-error-button"
      >
        {{ button.labelI18nKey | i18n }}
      </button>
    }
  }
  @case (RegistrationFinishViewState.PasswordForm) {
    <auth-input-password
      [email]="email"
      [flow]="inputPasswordFlow"
      [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
      [loading]="submitting"
      [primaryButtonText]="{ key: 'createAccount' }"
      [secondaryButtonText]="{ key: 'back' }"
      (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
      (onSecondaryButtonClick)="goBackToSignUp()"
    ></auth-input-password>
  }
}
